import type { Theme } from '@mui/material';

import { getBarColor } from 'src/components/dashboard/DashboardPage/widgets/OpenCommentsWidget/index.styles';

export const styles = {
  openCommentsLegend: (theme: Theme) => ({
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  }),

  listItem: (index: number) => (theme: Theme) => ({
    paddingLeft: 2,
    color: getBarColor(theme, index),

    '&:before': {
      content: '"\u2022"', // Unicode Character: “•”
      display: 'inline-block',
      fontSize: 40,
      marginLeft: theme.spacing(-2),
      position: 'absolute',
    },
  }),
};
